import React, { useState, useEffect } from "react";
import "./App.scss";
import Header from "./components/header";
import Cards from "./components/cards";
import Banner from "./components/banner";
import Partition from "./components/partition";
import Cats from "./components/cats";
import Video from "./components/video";
import Stats from "./components/stats";
import Product from "./components/product";
import Link from "./components/link";
import Products from "./components/products";
import Form from "./components/form";
import Footer from "./components/footer";
import Loading from "./components/loading";

import video from "./assets/images/final.m4v";
import cover from "./assets/images/Video-Cover.jpg";

import Aos from "aos";
import "aos/dist/aos.css";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    Aos.init();

  setTimeout(() => {
      setIsLoading(false);
    }, 2000);

  }, []);

  return (
    <div className="App">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Header />
          <Cards />
          <Banner />
          <div className="tripleBack">
            <Partition />
            <Cats />
            <Video src={video} poster={cover} />
          </div>
          <Stats />
          <Product />
          <Link />
          <Products />
          <Form />
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
